"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _futuresHelper = require("../../../../helpers/futuresHelper");
var _futuresSelectors = require("../../../../redux/futures/selectors/futuresSelectors");
var _modalActions = require("../../../../redux/actions/modalActions");
var _positionSelectors = require("../../../../redux/selectors/positionSelectors");
var _productsSelectors = require("../../../../redux/selectors/productsSelectors");
var _FuturesTradingComponent = _interopRequireDefault(require("./FuturesTradingComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _futuresKVPInfoSelect = (0, _futuresSelectors.futuresKVPInfoSelector)(state),
    futuresVerificationLevels = _futuresKVPInfoSelect.futuresVerificationLevels,
    minDepositValue = _futuresKVPInfoSelect.minDepositValue;
  var spotAccountInfo = (0, _futuresSelectors.mainAccountSelector)(state);
  var parsedFuturesVerificationLevels = (0, _futuresHelper.parseFuturesVerificationLevels)(futuresVerificationLevels);
  var spotAccountVerificationLevel = (spotAccountInfo === null || spotAccountInfo === void 0 ? void 0 : spotAccountInfo.VerificationLevel) || 0;
  var isSpotAccountFrozen = spotAccountInfo === null || spotAccountInfo === void 0 ? void 0 : spotAccountInfo.Frozen;
  var isVLCheckPassed = parsedFuturesVerificationLevels.includes(spotAccountVerificationLevel);
  var mainAccountTotalValue = (0, _positionSelectors.mainAccountPositionsTotalAmountSelector)(state);
  var baseAssetSymbol = (0, _productsSelectors.baseNotionalProductSymbolSelector)(state);
  var isSpotAccountBalanceValidationPassed = mainAccountTotalValue >= minDepositValue;
  var isAllChecksPassed = isVLCheckPassed && !isSpotAccountFrozen && isSpotAccountBalanceValidationPassed;
  var isDoubleWarning = (isSpotAccountFrozen || !isVLCheckPassed) && !isSpotAccountBalanceValidationPassed;
  return {
    futuresEnabled: (0, _futuresSelectors.futuresEnabledSelector)(state),
    isSpotAccountFrozen: isSpotAccountFrozen,
    minDepositValue: minDepositValue,
    baseAssetSymbol: baseAssetSymbol,
    isVLCheckPassed: isVLCheckPassed,
    isSpotAccountBalanceValidationPassed: isSpotAccountBalanceValidationPassed,
    isAllChecksPassed: isAllChecksPassed,
    isDoubleWarning: isDoubleWarning
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  openEnableFuturesTradingModal: function openEnableFuturesTradingModal(isReadOnly) {
    return (0, _modalActions.openModal)(_modalActions.MODAL_TYPES.FUTURES_TRADING, {
      isReadOnly: isReadOnly
    });
  }
})(_FuturesTradingComponent["default"]);